import { Injectable, signal } from '@angular/core';

import { environment } from '../../../environments/environment';
import { ThemeOption } from '../interfaces/theme.type';

const STORAGE_KEY = 'amaalmomineen-theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  readonly themes: ThemeOption[] = [
    { id: 'emerald-gold', label: 'Emerald & Gold', swatch: '#1f4d3a' },
    { id: 'royal-blue', label: 'Royal Blue', swatch: '#1e3a68' },
    { id: 'maroon-gold', label: 'Maroon & Gold', swatch: '#6b1f2a' },
    { id: 'teal-amber', label: 'Teal & Amber', swatch: '#0f5c6b' }
  ];

  private readonly defaultThemeId = this.themes.some((theme) => theme.id === environment.defaultTheme)
    ? environment.defaultTheme
    : this.themes[0].id;

  readonly currentTheme = signal<string>(this.defaultThemeId);

  constructor() {
    const stored = localStorage.getItem(STORAGE_KEY);
    const initial = this.themes.some((theme) => theme.id === stored) ? stored! : this.defaultThemeId;
    this.setTheme(initial);
  }

  setTheme(id: string): void {
    this.currentTheme.set(id);
    document.documentElement.setAttribute('data-theme', id);
    localStorage.setItem(STORAGE_KEY, id);
  }
}
